<script>
import { mapActions, mapGetters } from "vuex";
import UpcomingEventsSlider from "@/components/events/UpcomingEventsSlider.vue";
import PastEventCard from "@/components/events/PastEventCard.vue";
import SuggestEventDialog from "@/components/events/SuggestEventDialog.vue";
import { metricEventTypes, metricParents } from "@/lib";
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";

export default {
  name: "VeranstaltungenList",
  components: {Breadcrumbs, SuggestEventDialog, PastEventCard, UpcomingEventsSlider },
  data: () => ({
    selectedOrt: null,
    selectedZeitraum: null,
    selectedSortierung: "Neueste zuerst",
    availableSortierungen: ["Neueste zuerst", "Älteste zuerst"]
  }),
  mounted() {
    this.postHeartbeat({
      name: "Veranstaltungen Übersicht",
      type: metricEventTypes.PAGE_VISIT,
      parent: metricParents.NONE
    });
  },
  computed: {
    ...mapGetters("veranstaltungen", ["upcomingEvents", "pastEvents"]),
    orte() {
      return [
        "Alle Orte",
        ...new Set(this.pastEvents.map(event => event.Adresse.Ort))
      ];
    },
    jahre() {
      const years = [
        ...new Set(
          this.pastEvents
            .filter(e => e.Termin?.Datum)
            .map(event => event.Termin.Datum.split("-")[0])
        )
      ];
      years.sort((a, b) => parseInt(b) - parseInt(a)); // Sortiere Jahre abste
      return ["Alle Jahre", ...years];
    },
    filteredEvents() {
      const items = this.pastEvents
        .filter(
          e =>
            this.selectedOrt === null ||
            this.selectedOrt === "Alle Orte" ||
            e.Adresse.Ort === this.selectedOrt
        )
        .filter(
          e =>
            this.selectedZeitraum === null ||
            this.selectedZeitraum === "Alle Jahre" ||
            e.Termin.Datum.startsWith(this.selectedZeitraum)
        );

      if (this.selectedSortierung === "Neueste zuerst") {
        items.sort((a, b) => b.SortKey - a.SortKey);
      } else {
        items.sort((a, b) => a.SortKey - b.SortKey);
      }
      return items;
    }
  },
  methods: {
    ...mapActions("metrics", ["postHeartbeat"])
  }
};
</script>

<template>
  <div class="new-wrapper min-height-100">
    <div class="pt-10 px-5 py-2">
      <breadcrumbs />
      <div class="custom-header-text new-font-bold mb-5">Veranstaltungen</div>
      <p>
        Hier finden Sie alles rund um unsere Veranstaltungen – kompakt und
        aktuell.
      </p>
      <ul>
        <li>
          <b>Bevorstehende Veranstaltungen:</b> Entdecken Sie unsere nächsten
          Termine und sichern Sie sich direkt Ihren Platz.
        </li>
        <li>
          <b>Vergangene Veranstaltungen:</b> Werfen Sie einen Blick zurück und
          sehen Sie, was wir gemeinsam auf die Beine gestellt haben. Zu
          abgeschlossenen Veranstaltungen stellen wir Ihnen
          <b>Präsentationen, Materialien und weiterführende Inhalte</b> bereit –
          ergänzt durch eine Galerie mit den schönsten Impressionen. Für eine
          erfolgreiche Vernetzung finden Sie dort auch die
          <b>Teilnehmerlisten</b>.
        </li>
      </ul>
      <p>
        Alle Veranstaltungen sind <b>fotoöffentlich</b>. Das heißt: Während der
        Veranstaltungen entstehen Fotos, die wir für unsere Kommunikation
        nutzen.
      </p>
    </div>
    <div class="py-5 px-5 next-container">
      <div class="d-flex flex-wrap justify-space-between align-center" style="row-gap: 16px">
        <div class="veranstaltungen-subtitle">Zukünftige Veranstaltungen</div>
        <suggest-event-dialog />
      </div>
      <upcoming-events-slider />
    </div>
    <div class="pa-5 pt-10">
      <div class="veranstaltungen-subtitle">Bisherige Veranstaltungen</div>
      <div class="mt-7 d-flex">
        <div style="width: 150px" class="mr-2">
          <v-select
            background-color="rgb(232,212,223)"
            color="primary"
            label="Ort"
            :items="orte"
            v-model="selectedOrt"
            outlined
            single-line
            hide-details
            filled
            dense
          />
        </div>
        <div style="width: 150px">
          <v-select
            background-color="rgb(232,212,223)"
            color="primary"
            label="Zeitraum"
            :items="jahre"
            v-model="selectedZeitraum"
            outlined
            single-line
            hide-details
            filled
            dense
          />
        </div>
        <div class="flex-grow-1"></div>
        <div style="width: 200px">
          <v-select
            background-color="rgb(232,212,223)"
            color="primary"
            label="Sortierung"
            :items="availableSortierungen"
            v-model="selectedSortierung"
            outlined
            single-line
            hide-details
            filled
            dense
          />
        </div>
      </div>
      <past-event-card
        v-for="event in filteredEvents"
        :key="event.id"
        :event="event"
      />
    </div>
  </div>
</template>

<style scoped>
.veranstaltungen-subtitle {
  font-size: 24px;
  line-height: 20px;
  font-weight: bold;
}

.next-container {
  background-color: #b400550d;
}

.v-slide-group__content > *:first-child {
  margin-left: 0 !important;
}
.v-slide-group__content > *:last-child {
  margin-right: 0 !important;
}
</style>
